import React from "react";
import strings from "../../constants/strings";
import { Form, Button, Row } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import OTPInput from "react-otp-input";

export default function EnterOTP(props) {
  const {
    otp,
    buttonText,
    handleChange,
    handleNext,
    handleFormChange,
    handleResendConfirmationCode,
    showBack,
  } = props;

  return (
    <div className="landing-form">
      <Form
        onSubmit={(event) => {
          event.preventDefault();
          handleNext();
        }}
      >
        <Row className="d-block">
          <Form.Group className="h-100 mt-2">
            <Form.Label className="text-uppercase d-flex landing-label">
              {showBack && (
                <span
                  className="login-back-icon mr-3"
                  onClick={() => handleFormChange("password")}
                >
                  <FaArrowLeft size={25} />
                </span>
              )}
              {strings.OTP}
            </Form.Label>
            <div className="justify-content-center d-flex">
              <OTPInput
                inputStyle="single-otp"
                onChange={(otp) => handleChange(otp)}
                numInputs={6}
                value={otp}
                name="otp"
                shouldAutoFocus={true}
              />
            </div>
          </Form.Group>
        </Row>
        <Row className="d-flex justify-content-center">
          <span
            className="landing-links"
            onClick={handleResendConfirmationCode}
          >
            <p>{strings.RESEND_OTP}</p>
          </span>
        </Row>
        <Row className="mt-4">
          <Form.Group className="d-flex justify-content-center w-100">
            <Button
              variant="outline-warning"
              className="landing-button w-50"
              type="submit"
            >
              {buttonText}
            </Button>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}
